import React from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";

const UserFieldErrors = (props) => {

  const {property, userInfoErrors} = props;

  const errorsExist = Array.isArray(userInfoErrors[property]) && userInfoErrors[property].length;
  if (!errorsExist) {
    return null
  }

  return (
    <div className="ass-field__errors">
      {userInfoErrors[property].map((error) => {
        return (
          <span className="ass-field__errors-error" key={error}>
            <FormattedMessage id={error}/>
          </span>
        )
      })}
    </div>
  )
};

UserFieldErrors.propTypes = {
  property: PropTypes.string.isRequired,
};

const mapStateToProps = (store) => {
  const {userInfo, userInfoErrors} = store.userState;
  return {
    userInfo,
    userInfoErrors,
    // fabricatorData: store.fabricatorState,
  };
};

export default injectIntl(
  connect(mapStateToProps)(UserFieldErrors)
)
